export default __webpack_public_path__ + "static/media/avatar.88414ee0.jpeg";